// extracted by mini-css-extract-plugin
export default {"label":"ContactsSearch_label__mgwZY","input":"ContactsSearch_input__70Sq6"};